module.exports = __webpack_public_path__ + "static/media/15a-04_ST-2015-405x295mm-oleo-sobre-papel.f05eadda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15a/15a-04_ST-2015-405x295mm-oleo-sobre-papel.jpg
// module id = 157
// module chunks = 0